import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

const SettingsModal = ({ open, onClose, children, title = "Einstellungen" }: SettingsModalProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: "85vh",
          borderRadius: "16px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" px={2} pt={2}>
        <DialogTitle sx={{ fontWeight: "bold", flexGrow: 1 }}>{title}</DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          overflowY: "auto",
          padding: "1rem 2rem",
          flexGrow: 1
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default SettingsModal;
